import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import Button from '../Button';

const LoginPrompt = ({ openLogin, hasEventStarted }) => {
    return (
        <>
            {!hasEventStarted && (
                <Styled.LoginMessage>
                    Please log in with your ITV7 or Sky Bet account. Don&#39;t
                    have an account? Register to enter.
                </Styled.LoginMessage>
            )}
            <Styled.ButtonsWrapper>
                <Styled.LoginButtonWrapper>
                    <Button
                        type="secondary"
                        buttonText="LOGIN"
                        disabled={false}
                        onClick={openLogin}
                    />
                </Styled.LoginButtonWrapper>
                <Styled.RegisterButtonWrapper>
                    <Button
                        type="default"
                        buttonText="REGISTER"
                        disabled={false}
                        onClick={openLogin}
                    />
                </Styled.RegisterButtonWrapper>
            </Styled.ButtonsWrapper>
        </>
    );
};

LoginPrompt.propTypes = {
    openLogin: PropTypes.func.isRequired,
    hasEventStarted: PropTypes.bool.isRequired
};

export default LoginPrompt;
